import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../../../../../models/base/base-component';
import { StiiizyBusinessCardStackContentViewModel } from '../stiiizy-business-card-stack-content-view-model';
import { StiiizyCardData } from '../../../../../../../../models/print-cards/stiiizy-card-data';

@Component({
  selector: 'app-stiiizy-business-side-bar',
  templateUrl: './stiiizy-business-side-bar.component.html',
  styleUrls: ['./stiiizy-business-side-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class StiiizyBusinessSideBarComponent extends BaseComponent {
  constructor(
    public viewModel: StiiizyBusinessCardStackContentViewModel // provided by parent component
  ) {
    super();
  }

  @Input() maxHeightInPx: number;
  @Input() maxWidthInPx: number;
  @Input() cardData: StiiizyCardData;

  setupViews() {}
  setupBindings() {}
}
